import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ui/ErrorBoundary.jsx';
import AppProviders from './AppProvider';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(),Sentry.replayIntegration()],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost",/^https:\/\/handpreneur\.com\/api/],
  sendDefaultPii: true,
  enableLogs: true
});

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}


window.addEventListener(
  'error',
  (e) => {
    const isChunkLoadError = e.message &&
      (e.message.toLowerCase().includes('failed to load module script') ||
        e.message.toLowerCase().includes('error loading script'));

    if (isChunkLoadError) {
      console.warn('Chunk load failure detected. Forcing page refresh...');
      window.location.reload();
    }
  },
  true
);


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
      <ErrorBoundary>
        <AppProviders>
          <App />
        </AppProviders>
      </ErrorBoundary>
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
